import api from '@/utils/axios';
import { unwrapItem } from '@/utils/apiHelpers';
import type { ApiUserNotification } from '@/domains/api/types';

export async function fetchUserNotifications(): Promise<{ notifications: ApiUserNotification[]; unread_count: number }> {
  const res = await api.get('/notifications');
  const data = unwrapItem<{ notifications: ApiUserNotification[]; unread_count: number }>(res.data);
  return data;
}

export async function markUserNotificationRead(id: number): Promise<ApiUserNotification> {
  const res = await api.post(`/notifications/${id}/read`);
  return unwrapItem<ApiUserNotification>(res.data);
}

export async function markAllUserNotificationsRead(): Promise<void> {
  await api.post('/notifications/read-all');
}
